import React from 'react';

export default ({
  className = '',
  color = '#292F36',
  width = 73,
  height = 63,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 22"
    className={className}
    fill={color}
  >
    <path d="M18.26 3.75a10.3 10.3 0 0 0-7.54-3.1c-2.95 0-5.47 1.03-7.57 3.1a10.38 10.38 0 0 0-3.1 7.57c0 2.96 1.03 5.47 3.1 7.54 2.1 2.1 4.62 3.14 7.57 3.14s5.46-1.05 7.54-3.14a10.2 10.2 0 0 0 3.14-7.54c0-2.95-1.05-5.47-3.14-7.57zm-8.33.35h1.58v1.68c1.2.1 2.07.5 2.6 1.23l-.87 1.53c-1.2-1-2.3-1.26-3.33-.78C9.1 8.28 9 8.9 9.6 9.65c.15.18.47.39.98.64l1.27.44c.85.3 1.53.77 2.06 1.4.54.65.62 1.59.23 2.83-.42 1.03-1.27 1.69-2.54 1.98l-.01 1.65H9.94l-.01-1.64a5.7 5.7 0 0 1-1.84-.6c-.57-.3-.96-.64-1.17-1.04l1.09-1.35c1 .75 1.85 1.14 2.57 1.16 1.07 0 1.65-.37 1.74-1.12.06-.64-.4-1.14-1.38-1.51-1.36-.54-2.2-.94-2.53-1.2a3.08 3.08 0 0 1-1.22-3.02c.23-1.27 1.14-2.1 2.74-2.5V4.1z" />
  </svg>
);
